export interface JournalImageRecord {
  id: string;
  image_url: string;
  filename?: string;
  x_position: number;
  y_position: number;
  z_position: number;
  width: number;
  height: number;
}

export interface JournalRecord {
  journal_id: string;
  title: string;
  content: string;
  emoticon?: string;
  created_at: string;
  updated_at?: string;
  images: JournalImageRecord[];
  authoredDevice?: 'pc' | 'mobile';
  authoredCanvasWidth?: number;
}

const toFiniteNumber = (value: unknown, fallback: number) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const normalizeJournalImages = (payload: any): JournalImageRecord[] => {
  if (!Array.isArray(payload)) return [];

  return payload
    .filter(item => item && typeof item === 'object' && (item.image_url || item.imageUrl || item.url))
    .slice(0, 3)
    .map((item, index) => ({
      id: String(item.id ?? item.image_id ?? item.imageId ?? `image-${index}`),
      image_url: String(item.image_url ?? item.imageUrl ?? item.url),
      filename: item.filename ? String(item.filename) : undefined,
      x_position: toFiniteNumber(item.x_position ?? item.xPosition, 24 + index * 32),
      y_position: toFiniteNumber(item.y_position ?? item.yPosition, 28 + index * 26),
      z_position: toFiniteNumber(item.z_position ?? item.zPosition ?? item.rotation, index % 2 ? 3 : -3),
      width: toFiniteNumber(item.width, 168),
      height: toFiniteNumber(item.height, 126),
    }));
};

const findJournalArray = (payload: any): any[] => {
  const candidates = [
    payload,
    payload?.data,
    payload?.journals,
    payload?.result,
    payload?.data?.journals,
    payload?.data?.items,
    payload?.data?.list,
    payload?.data?.content,
    payload?.items,
    payload?.list,
    payload?.content,
    payload?.result?.journals,
    payload?.result?.items,
    payload?.result?.list,
  ];
  return candidates.find(Array.isArray) ?? [];
};

export const normalizeJournalList = (payload: any): JournalRecord[] =>
  findJournalArray(payload)
    .filter(item => item && typeof item === 'object')
    .map((item, index) => {
      const createdAt = item.created_at ?? item.createdAt ?? item.date ?? item.updated_at ?? item.updatedAt ?? '';
      const rawId = item.journal_id ?? item.journalId ?? item.id ?? item._id;
      return {
        journal_id: String(rawId ?? `journal-${createdAt || index}`),
        title: String(item.title ?? item.subject ?? ''),
        content: String(item.content ?? item.body ?? item.text ?? ''),
        emoticon: item.emoticon ?? item.emoji ?? item.emotion,
        created_at: String(createdAt),
        updated_at: item.updated_at ?? item.updatedAt,
        images: normalizeJournalImages(item.images ?? item.journal_images ?? item.attachments),
      };
    });
